// extracted by mini-css-extract-plugin
module.exports = {"Title":"style_Title__1SoFH"};